import { gql, useQuery } from '@apollo/client';
import * as React from 'react';
import { IsLoggedInQuery } from '../generated/graphql';

// todo: add user
interface IAuth {
  isLoggedIn: boolean;
  user: string |null| undefined
}

export const AuthContext = React.createContext<{
  auth: IAuth;
}>({ auth: { isLoggedIn: false, user: null } });

export const AuthContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null => {
  const IS_USER_LOGGED_IN = gql`
    query isLoggedIn {
      isLoggedIn {
        loggedIn
        user
      }
    }
  `;
  const { loading, data } = useQuery<IsLoggedInQuery>(IS_USER_LOGGED_IN);

  const auth = React.useMemo(() => {
    if (data?.isLoggedIn?.loggedIn) {
      return { isLoggedIn: true, user: data.isLoggedIn.user };
    }
    return { isLoggedIn: false, user: null };
  }, [data]);

  if (loading) return null;

  return <AuthContext.Provider value={{ auth }}>{children}</AuthContext.Provider>;
};

export const useAuth = (): IAuth => {
  const { auth } = React.useContext(AuthContext);
  return auth;
};
